import React from "react";
import { Button, Icon } from "antd";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  width: 700px;
  margin: auto;
  margin-top: 10px;
  padding: 24px;
  border-radius: 12px;
  background: white;
  display: flex;
  justify-content: center;
`;

const Li = styled.li`
  letter-spacing: 0.1px;
  font-size: 15px;
`;

const Text = styled.div`
  flex: 1;
  margin-left: 20px;

  h1 {
    font-size: 20px;
  }
`;

const NonResults = ({ title, messages = [], link }) => {
  return (
    <Wrapper>
      <Icon
        style={{
          color: "#747c84",
          fontSize: 48
        }}
        type="frown"
      />
      <Text>
        <h1>{title}</h1>
        <ul style={{ marginLeft: 20, marginBottom: 10 }}>
          {messages.map(message => (
            <Li key={message}>{message}</Li>
          ))}
        </ul>
        {link && (
          <Link to={link.to}>
            <Button
              icon={link.icon}
              ghost
              size="small"
              style={{ color: "#000" }}
              type="link"
            >
              {link.text}
            </Button>
          </Link>
        )}
      </Text>
    </Wrapper>
  );
};

export default NonResults;
